export const STORAGE_KEY_SPONSORED_TX = 'TETU_GAME_SPONSORED_TX';
export const STORAGE_KEY_PLAY_MUSIC = 'TETU_GAME_PLAY_MUSIC';
export const STORAGE_KEY_PLAY_EFFECTS = 'TETU_GAME_PLAY_EFFECTS';
export const STORAGE_KEY_SETTINGS_PREFIX = 'TETU_GAME_SETTING_';
export const STORAGE_KEY_MUSIC_VOLUME = 'TETU_GAME_MUSIC_VOLUME';
export const STORAGE_KEY_EFFECTS_VOLUME = 'TETU_GAME_EFFECTS_VOLUME';
export const STORAGE_KEY_SACRA_LANG = 'SACRA_LANG';
